import React from 'react';
import { Home, MapPin, Calendar, FileText, Users, User } from 'lucide-react';

const Navigation = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'welcome', label: 'Home', icon: Home, description: 'Go to home page' },
    { id: 'map', label: 'Map', icon: MapPin, description: 'Find accessible venues' },
    { id: 'events', label: 'Events', icon: Calendar, description: 'Discover inclusive events' },
    { id: 'iep', label: 'IEP Hub', icon: FileText, description: 'IEP resources & tools' },
    { id: 'community', label: 'Community', icon: Users, description: 'Parent discussions' },
    { id: 'profile', label: 'Profile', icon: User, description: 'Your account & stats' }
  ];

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm" role="navigation" aria-label="Main navigation">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
        <div className="flex justify-between space-x-2 sm:space-x-4 overflow-x-auto py-3 sm:py-4">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex flex-col items-center min-w-0 flex-shrink-0 px-2 sm:px-3 py-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                  isActive 
                    ? 'bg-blue-50 text-blue-700 border-2 border-blue-200' 
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
                data-testid={`nav-${tab.id}`}
                aria-current={isActive ? 'page' : undefined}
                aria-describedby={`${tab.id}-description`}
              >
                <Icon size={20} className="mb-1 sm:mb-1" aria-hidden="true" />
                <span className="text-xs sm:text-sm font-medium text-center leading-tight">{tab.label}</span>
                <span id={`${tab.id}-description`} className="sr-only">{tab.description}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;